import { useState } from 'react'
import { Notifications } from 'library/constants'

import SFXS from '../../../assets/audios/audios'

export default function useProvablyHandlers(
  sendSeed?: any,
  handleNotification?: any,
  audio?: any
) {
  const { setSeedSFX } = SFXS
  setSeedSFX.volume = audio.volume

  const [seed, setSeed] = useState<string>('')
  const [seedError, setSeedError] = useState<boolean>(false)

  const handleChange = (s: any) => {
    const val = s.target.value
    const onlyLatinCharsAndNumbers = /^[A-Za-z0-9]+$/
    if (onlyLatinCharsAndNumbers.test(val) || val === '') {
      setSeed(val)
    }
    if (val.length >= 16 && val.length <= 128) {
      setSeedError(false)
      handleNotification(false)
    }
  }
  const handleSubmit = (s?: string) => {
    if (seed.length >= 16 && seed.length <= 128) {
      audio.sound && setSeedSFX.play()
      sendSeed(s)
      setSeedError(false)
      setSeed('')
    } else {
      setSeedError(true)
      handleNotification(Notifications.invalidSeed)
    }
  }

  return { handleChange, handleSubmit, seed, seedError }
}
